import React from 'react'
import { Redirect } from 'react-router-dom'
import { FuseLoadable } from '@fuse'
import { authRoles } from 'auth'

export const SettingsAppConfig = {
  settings: {
    layout: {}
  },
  auth: authRoles.admin,
  routes: [
    {
      path: process.env.PUBLIC_URL + '/settings/app',
      component: FuseLoadable({
        loader: () => import('./app/App')
      })
    },
    {
      path: process.env.PUBLIC_URL + '/settings',
      component: () => <Redirect to="/settings/app" />
    }
  ]
}
